import React from "react";

const SVG = ({
    style = {},
    fill = "#000",
    width = "10px",
    height = "17px",
    className = "",
    viewBox = "0 0 24 24"
}) => (
        <svg
            width={height}
            style={style}
            height={height}
            viewBox={viewBox}
            xmlns="http://www.w3.org/2000/svg"
            className={`svg-icon ${className || ""}`}
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                fill={fill}
                d="M16.5319824,22.0429688 C17.0700684,22.0429688 17.4968262,21.5883789 17.4968262,21.0688477 C17.4968262,20.5585938 17.0700684,20.1040039 16.5319824,20.1040039 L15.2702637,20.1040039 L15.0383301,18.6010742 L20.3913574,18.6010742 C22.2653809,18.6010742 23.3044434,17.5805664 23.3044434,15.6879883 L23.3044434,5.47363281 C23.3044434,3.58105469 22.2653809,2.56054688 20.3913574,2.56054688 L3.60864258,2.56054688 C1.73461914,2.56054688 0.695556641,3.58105469 0.695556641,5.47363281 L0.695556641,15.6879883 C0.695556641,17.5805664 1.73461914,18.6010742 3.60864258,18.6010742 L8.96166992,18.6010742 L8.72973633,20.1040039 L7.46801758,20.1040039 C6.93920898,20.1040039 6.50317383,20.5585938 6.50317383,21.0688477 C6.50317383,21.5883789 6.93920898,22.0429688 7.46801758,22.0429688 L16.5319824,22.0429688 Z M20.5861816,14.0087891 L3.41381836,14.0087891 C3.16333008,14.0087891 3.04272461,13.9067383 3.04272461,13.6376953 L3.04272461,5.74267578 C3.04272461,5.13964844 3.31176758,4.91699219 3.87768555,4.91699219 L20.1223145,4.91699219 C20.6882324,4.91699219 20.9572754,5.13964844 20.9572754,5.74267578 L20.9572754,13.6376953 C20.9572754,13.9067383 20.8366699,14.0087891 20.5861816,14.0087891 Z M12.0046387,17.7011719 C11.4108887,17.7011719 10.9284668,17.2280273 10.9284668,16.6342773 C10.9284668,16.0498047 11.4108887,15.5673828 12.0046387,15.5673828 C12.579834,15.5673828 13.0715332,16.0498047 13.0715332,16.6342773 C13.0715332,17.2280273 12.579834,17.7011719 12.0046387,17.7011719 Z"
            />
        </svg>
    );

export default SVG;
